import request from "@/utils/request";
import { ITypeModel } from "@/api/types";

export const getContainerType = () =>
  request({
    url: "/container-types",
    method: "get"
  });


export const deleteContainerTypeRelations = (id: string, data: any) =>
  request({
    url: `/container-types/${id}/relations`,
    method: "DELETE",
      data
  });

export const updateContainerTypeLoadingType = (id: string, data: { loadingInOneOrMorePlaces: boolean }) =>
  request({
    url: `/container-types/${id}/loading-type`,
    method: "PUT",
    data
  });

export const updateContainerTypeRemark = (id: string, data: any) =>
  request({
    url: `/container-types/${id}/remark`,
    method: "PUT",
    data
  });


